const updateAddToCartBtn = (atcBtnEl: HTMLButtonElement | null, disable = false): void => {
  if (!atcBtnEl) return;
  atcBtnEl.disabled = disable;
  atcBtnEl.textContent = String(atcBtnEl.dataset.atcText);
};

export default updateAddToCartBtn;
